import React from 'react';
import ReactDOM from 'react-dom';
import {Router, hashHistory} from 'react-router';
import {Provider} from 'react-redux';
// import {Router, Route, hashHistory, BrowserRouter, browserHistory} from 'react-router';
import registerServiceWorker from './registerServiceWorker';
import routes from './routes';
import configureStore from './store/configureStore';

const store = configureStore;

ReactDOM.render((
	<Provider store={store}>
		<Router history={hashHistory} routes={routes} />
	</Provider>
), document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js